import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-two-factor-reset-confirmtion-dialog',
    templateUrl: './two-factor-reset-confirmtion-dialog.component.html',
    styleUrls: ['./two-factor-reset-confirmtion-dialog.component.scss'],
    standalone: false
})
export class TwoFactorResetConfirmtionDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
  }


  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
